const PbxxRecord = require('../pbxx_record')

module.exports = class ShareSettingCopyOption extends PbxxRecord {
  static get class_name() {
    return 'ShareSettingCopyOption'
  }
}
